/**
 * @param {import('next').NextConfig} nextConfig
 */
const cspHeaderPlugin = (nextConfig = {}) => {
  const cspHeaderKey =
    process.env.NODE_ENV === 'development'
      ? 'Content-Security-Policy-Report-Only'
      : 'Content-Security-Policy';

  return Object.assign({}, nextConfig, {
    async headers() {
      const extendHeaders =
        typeof nextConfig.headers === 'function' ? await nextConfig.headers() : [];
      return [
        ...(await extendHeaders),
        {
          source: '/:path*',
          headers: [
            {
              key: cspHeaderKey,
              value:
                `default-src 'self' 'unsafe-inline' 'unsafe-eval' *.youtube.com *.googlesyndication.com *.googletagmanager.com browser-intake-us5-datadoghq.com *.sitecorecloud.io *.gstatic.com *.coveo.com *.launchdarkly.com px.ads.linkedin.com urldefense.com fg8vvsvnieiv3ej16jby.litix.io *.panoskin.com *.tourbuilder.com *.sitecore.net *.siteimprove.net *.siteimprove.com *.adobeaemcloud.com *.googleapis.com *.wistia.net *.youtube.com *.reputation.com *.json *.cookielaw.org *.onetrust.com *.google.com *.doubleclick.net *.nr-data.net *.wistia.com *.google-analytics.com https://main-api-276474891420.us-central1.run.app widgets.peek.us my.matterport.com  views.ovalroomgroup.com 3dplans.com tours.atlasbayvr.com viewer.panoskin.com https://schema-cf.bc0a.com/corejs/be-schema-v3.js helixmedia360.com data:;` +
                `script-src 'self' 'unsafe-inline' 'unsafe-eval' *.sitecorecloud.io feaasstatic.blob.core.windows.net snap.licdn.com *.wistia.net *.wistia.com *.googleapis.com *.googletagmanager.com cdn.cookielaw.org *.btstatic.com *.baidu.com *.google.com apis.google.com *.gstatic.com *.nr-data.net *.myfiona.com *.fluencyinc.co *.sentry-cdn.com widgets.peek.us my.matterport.com views.ovalroomgroup.com 3dplans.com tours.atlasbayvr.com viewer.panoskin.com helixmedia360.com blob:;` +
                `style-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://edge-platform.sitecorecloud.io;` +
                `img-src 'self' 'unsafe-inline' *.google.co.uk *.assetsadobe.com *.googleadservices.com *.ads.linkedin.com *.wistia.com *.wistia.net https://s7d9.scene7.com https://cdn.sightmap.com *.googleapis.com *.gstatic.com *.googletagmanager.com embedwistia-a.akamaihd.net *.cookielaw.org widgets.peek.us my.matterport.com views.ovalroomgroup.com 3dplans.com tours.atlasbayvr.com viewer.panoskin.com helixmedia360.com data:;` +
                `font-src 'self' 'unsafe-inline' https://fonts.gstatic.com *.wistia.com *.wistia.net data:;` +
                `frame-ancestors 'self' *.google.com widgets.peek.us my.matterport.com views.ovalroomgroup.com 3dplans.com tours.atlasbayvr.com viewer.panoskin.com helixmedia360.com surveys.reputation.com;` +
                `media-src 'self' 'unsafe-inline' *.wistia.com *.wistia.net data: blob:;` +
                `object-src 'none';` +
                `upgrade-insecure-requests; block-all-mixed-content;`,
            },
          ],
        },
      ];
    },
  });
};

module.exports = cspHeaderPlugin;
